import React, { useState } from "react";
import EntityHeader from "./common/EntityHeader";
import Card from "react-bootstrap/Card";
import FieldDisplay from "./common/FieldDisplay";
import {
  getFieldDate,
  getFieldName,
  getFieldText,
} from "../scripts/helperScripts";
import FosterHomeMemberModal from "./common/FosterHomeMemberModal";

function FosterHomeMembersEntity({ fosterHome, members, updateMembers }) {
  const [isOpen, setIsOpen] = useState(false);
  const [fosterHomeMemberData, setFosterHomeMemberData] = useState();
  const [showExpired, setShowExpired] = useState(false);

  const hideModal = () => {
    setIsOpen(false);
  };

  const showModal = (fosterHomeMember) => {
    const fosterHomeMemberObj = {
      ccx_fosterhomememberid: fosterHomeMember.ccx_fosterhomememberid,
      ccx_name: fosterHomeMember.ccx_name,
      ccx_contact: getFieldText(fosterHomeMember.ccx_contact),
      ccx_homemembertype: getFieldText(fosterHomeMember.ccx_homemembertype),
      ccx_primarycontact:
        getFieldName(fosterHomeMember.ccx_primarycontact) === "Yes",
      sfy_effectivedate: getFieldDate(fosterHomeMember.sfy_effectivedate),
      sfy_expirationdate: getFieldDate(fosterHomeMember.sfy_expirationdate),
    };
    setFosterHomeMemberData(fosterHomeMemberObj);
    setIsOpen(true);
  };

  const addNew = () => {
    setFosterHomeMemberData(undefined);
    setIsOpen(true);
  };

  const filterMembers = () => {
    let filtered = members;
    if (!showExpired)
      filtered = filtered.filter(
        (member) => member.sfy_expirationdate === undefined
      );
    return filtered;
  };

  return (
    <>
      {isOpen ? (
        <FosterHomeMemberModal
          isOpen={isOpen}
          hideModal={hideModal}
          fosterHome={fosterHome}
          initialData={fosterHomeMemberData}
          updateMembers={updateMembers}
        ></FosterHomeMemberModal>
      ) : null}
      <div className="clearfix">
        <div className="form-check form-switch float-end mb-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="expiredMembers"
            checked={showExpired}
            onChange={(e) => setShowExpired(!showExpired)}
          />
          <label className="form-check-label" htmlFor="expiredMembers">
            Show Expired
          </label>
        </div>
      </div>
      <EntityHeader
        title="Foster Home Members"
        add={addNew}
        body={
          <div className="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 row-cols-xl-2 mb-4">
            {filterMembers().map((member) => (
              <div className="col p-2" key={member.ccx_fosterhomememberid}>
                <Card className="card-safy">
                  <Card.Header
                    className="p-0 ps-2 bg-safy1-1"
                    style={{ color: "white" }}
                  >
                    <div className="row">
                      <div className="col-10 ps-4 pt-1">
                        <a
                          className="text-white"
                          href={`/contact/${getFieldText(member.ccx_contact)}`}
                        >
                          {getFieldName(member.ccx_contact)}
                        </a>
                      </div>
                      <div className="col-2">
                        <i
                          className="fas fa-pen float-end p-2"
                          onClick={() => {
                            showModal(member);
                          }}
                        ></i>
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Body
                    className={
                      member.sfy_expirationdate === undefined
                        ? "p-2 card-body-safy"
                        : "p-2 bg-warning"
                    }
                  >
                    {member.ccx_contact && (
                      <FieldDisplay
                        label="Contact:"
                        value={getFieldName(member.ccx_contact)}
                      />
                    )}
                    {member.ccx_primarycontact && (
                      <FieldDisplay
                        label="Primary Contact"
                        value={getFieldName(member.ccx_primarycontact)}
                      />
                    )}
                    {member.ccx_homemembertype && (
                      <FieldDisplay
                        label="Member Type:"
                        value={getFieldName(member.ccx_homemembertype)}
                      />
                    )}
                    {member.sfy_effectivedate && (
                      <FieldDisplay
                        label="Effective Date:"
                        value={getFieldDate(member.sfy_effectivedate)}
                      />
                    )}
                    {member["con.mobilephone"] && (
                      <FieldDisplay
                        label="Mobile Phone:"
                        value={member["con.mobilephone"]}
                      />
                    )}
                    {member["con.telephone2"] && (
                      <FieldDisplay
                        label="Home Phone:"
                        value={member["con.telephone2"]}
                      />
                    )}
                    {member["con.emailaddress1"] && (
                      <FieldDisplay
                        label="Email Address:"
                        value={member["con.emailaddress1"]}
                      />
                    )}
                    {member["con.emailaddress2"] && (
                      <FieldDisplay
                        label="Email Address:"
                        value={member["con.emailaddress2"]}
                      />
                    )}
                  </Card.Body>
                </Card>
              </div>
            ))}
          </div>
        }
      />
    </>
  );
}

export default FosterHomeMembersEntity;
